import React, { FC, useState, useEffect } from 'react';

export interface IBfiNumperOptions {
    id: string;
    value?: string;
    required?: boolean;
    isValid?: boolean;
    onChange(value: string): void;
    disabled: boolean;
}

export const BfiNumber: FC<IBfiNumperOptions> = ({
    id = 'bfiNumber',
    value = '',
    onChange,
    required = false,
    isValid = true,
    disabled = false,
}) => {
    const rgxString = '^[0-9A-Z]{1,9}$';

    const [isNumberValid, set_isNumberValid] = useState(true);

    useEffect(() => {
        if (!value) {
            set_isNumberValid(true);
            return;
        }
        const isOk = validateNumber(value);
        set_isNumberValid(isOk);
    }, [value]);

    const validateNumber = (input) => {
        if (!input) {
            return true;
        }
        const rgx = new RegExp(rgxString, 'g');
        const isOk = rgx.test(input);
        return isOk;
    };

    const onNumberChange = (input) => {
        let cleanedInput = (input ?? '').toUpperCase();
        cleanedInput = cleanedInput.replace(/[^0-9A-Z]/g, '');
        onChange && onChange(cleanedInput);
    };

    return (
        <input
            className={!isValid || !isNumberValid ? 'not-valid' : undefined}
            type='text'
            value={value ?? ''}
            id={id}
            onChange={(event) => onNumberChange(event.target.value)}
            pattern={rgxString}
            maxLength={9}
            required={required}
            disabled={disabled}
        />
    );
};
